// Captures Chrome's beforeinstallprompt as early as possible and shares it app-wide.
let deferred = null;
const listeners = new Set();

if (typeof window !== "undefined") {
  window.addEventListener("beforeinstallprompt", (e) => {
    e.preventDefault();
    deferred = e;
    listeners.forEach((cb) => cb(e));
  });
  window.addEventListener("appinstalled", () => {
    deferred = null;
    listeners.forEach((cb) => cb(null));
  });
}

export function getInstallEvent() { return deferred; }
export function onInstallEvent(cb) { listeners.add(cb); return () => listeners.delete(cb); }
export async function promptInstall() {
  if (!deferred) return false;
  deferred.prompt();
  try { await deferred.userChoice; } catch { /* ignore */ }
  deferred = null;
  listeners.forEach((cb) => cb(null));
  return true;
}
export function isIOS() { return /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream; }
export function isAndroid() { return /Android/i.test(navigator.userAgent); }
export function isStandalone() {
  return window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;
}
